import Stage from "@frog/source/models/Stage.js"
import Delta from "@frog/source/models/Delta.js"

export default class Step {
    static instantiate(step) {
        if(step.alphastage == undefined) {
            throw new Error("Needs alphastage")
        }

        step.deltastages = step.deltastages || []

        step.omegastage = Stage.copy(step.alphastage)
        step.deltastages.forEach((deltastage) => {
            step.omegastage = Delta.editStage(step.omegastage, deltastage)
        })

        return step
    }
    static add(step, deltastages) {
        if(deltastages == undefined) {
            return
        }
        if(deltastages instanceof Array) {
            deltastages.forEach((deltastage) => {
                step.deltastages.push(deltastage)
                step.omegastage = Delta.editStage(step.omegastage, deltastage)
            })
        } else {
            const deltastage = deltastages
            step.deltastages.push(deltastage)
            step.omegastage = Delta.editStage(step.omegastage, deltastage)
        }
    }
}
